export default __webpack_public_path__ + "plus_icon.svg";